import "@/App.css";
import "@/i18n";  // initialize i18next
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PlayerProvider } from "@/context/PlayerContext";
import { Toaster } from "@/components/ui/sonner";

import Editor from "@/pages/Editor";
import PlayCustom from "@/pages/PlayCustom";
import Landing from "@/pages/Landing";
import Profile from "@/pages/Profile";
import LevelMap from "@/pages/LevelMap";
import Play from "@/pages/Play";
import Grimoire from "@/pages/Grimoire";
import Parental from "@/pages/Parental";
import Family from "@/pages/Family";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import LegalNotice from "@/pages/LegalNotice";
import Press from "@/pages/Press";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Achievements from "@/pages/Achievements";
import AchievementWatcher from "@/components/AchievementWatcher";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import EveilPassportWatcher from "@/components/EveilPassportWatcher";
import ConsentBanner from "@/components/ConsentBanner";
import Onboarding from "@/components/Onboarding";
import { useParams } from "react-router-dom";

function PlayRoute() {
  const { levelId } = useParams();
  return <Play key={levelId} />;
}

function DocTitle() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.title = `Chronos Time Puzzle — ${t("landing.hero_line1")} ${t("landing.hero_line2")}`;
  }, [t, i18n.language]);
  return null;
}

function App() {
  return (
    <div className="App">
      <PlayerProvider>
        <BrowserRouter>
          <DocTitle />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/levels" element={<LevelMap />} />
            <Route path="/play/:levelId" element={<PlayRoute />} />
            <Route path="/grimoire" element={<Grimoire />} />
            <Route path="/parental" element={<Parental />} />
            <Route path="/family" element={<Family />} />
            <Route path="/editor" element={<Editor />} />
            <Route path="/play-custom/:shareCode" element={<PlayCustom />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/press" element={<Press />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/achievements" element={<Achievements />} />
          </Routes>
          <Onboarding />
          <ConsentBanner />
          <AchievementWatcher />
          <PWAInstallPrompt />
          <EveilPassportWatcher />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          offset={80}
          toastOptions={{
            classNames: {
              toast: "bg-stone-900 border border-white/10 text-stone-100 font-sans",
            },
          }}
        />
      </PlayerProvider>
    </div>
  );
}

export default App;
